import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ element }) => {
  const user = useSelector((state) => state.userdata.loggedIn);
  const isLoaded = useSelector((state) => state.userdata.isUserDataLoaded)

  if(!isLoaded){
    if (!user) {
      // Redirect unauthenticated users to the home page
      return <Navigate to="/" replace />;
    }
  }

  return element; // Render the protected route
};

export default PrivateRoute;
